import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { api } from "../../../../lib/api";
import { AttachmentButton } from "./AttachmentButton";
import { UserAttachmentPreviewModal } from "./UserAttachmentPreviewModal";

interface UserAttachment {
  id: string;
  filename: string;
  content: string;
  size: number;
  lastModified?: number;
}

interface UserAttachmentsProps {
  messageId: string;
  projectId: string;
}

export function UserAttachments({
  messageId,
  projectId,
}: UserAttachmentsProps) {
  const [previewFile, setPreviewFile] = useState<UserAttachment | null>(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const { data: attachments = [] } = useQuery({
    queryKey: ["message-attachments", projectId, messageId],
    queryFn: async () => {
      const response = await api.getMessageAttachments(projectId, messageId);
      return response.data || [];
    },
  });

  const handleFileClick = (file: UserAttachment) => {
    setPreviewFile(file);
    setIsPreviewOpen(true);
  };

  const handleClosePreview = () => {
    setIsPreviewOpen(false);
    setPreviewFile(null);
  };

  if (attachments.length === 0) {
    return null;
  }

  return (
    <div className="flex gap-1 flex-wrap">
      {attachments.map((file) => (
        <AttachmentButton
          key={file.id}
          name={file.filename}
          size={file.size}
          onClick={() => handleFileClick(file)}
          variant="compact"
        />
      ))}

      <UserAttachmentPreviewModal
        attachment={
          previewFile
            ? {
                id: previewFile.id,
                name: previewFile.filename,
                content: previewFile.content,
                size: previewFile.size,
                lastModified: previewFile.lastModified || Date.now(),
              }
            : null
        }
        isOpen={isPreviewOpen}
        onClose={handleClosePreview}
      />
    </div>
  );
}
